import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import dayjs from 'dayjs'
import isoWeek from 'dayjs/plugin/isoWeek'
import { z } from 'zod'
import { defaultWeekFilter } from '../wo1110/list.schema'

dayjs.extend(isoWeek)

export const Wo1010SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    fromDate: z.coerce
      .date()
      .default(defaultWeekFilter.startDate)
      .transform((v) => dayjs(v).startOf('isoWeek').toDate()),
    toDate: z.coerce
      .date()
      .default(defaultWeekFilter.endDate)
      .transform((v) => dayjs(v).endOf('isoWeek').toDate()),
    partyId: z.union([z.number(), z.string()]).optional(),
    itemId: z.union([z.number(), z.string()]).optional(),
    status: z
      .union([z.literal('1'), z.literal('2'), z.literal('3'), z.literal('4')])
      .optional(),
  })
  .merge(BasePaginateParamsSchema)
export type Wo1010SearchParams = z.infer<typeof Wo1010SearchParamsSchema>

export const Wo1010SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  deliveryDate: z.coerce.date(),
  productionDate: z.coerce.date(),
  partyId: z.number().nullable(),
  partyName: z.string().nullable(),
  refNo: z.string().nullable(),
  refDate: z.coerce.date().nullable(),
  itemId: z.number().nullable(),
  qty: z.number(),
  remark: z.string().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isTestProduction: z.boolean(),
})

export type Wo1010SearchResultModel = z.infer<
  typeof Wo1010SearchResultModelSchema
>

export const Wo1010SearchResultSchema = z
  .object({
    data: z.array(Wo1010SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Wo1010SearchResult = z.infer<typeof Wo1010SearchResultSchema>
